module.exports = __webpack_public_path__ + "img/47.0ab710e5.jpg";